// tslint:disable:only-arrow-functions

import {
  PulseConfigurationKeys,
  PULSE_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/pulse-rules';
import { CONFIGURATIONS_PROVIDER_KEY } from '@epicuro-next/data-providers/providers-registry';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { FloatRange } from 'graphql-api/gql-api-interfaces';

export const productDiscountLabel: IDynamicItem = {
  id: 'product-discount-label',
  contentTypeId: 'dynamic-elements-discount-label',

  if: [
    'AND',
    [
      [
        'OR',
        [
          [
            'EQ',
            [
              {
                provider: 'GlobalStoreProviderService',
                property: {
                  paths: 'user.showWholeSalePrices',
                },
              },
              true,
            ],
          ],
          [
            'EQ',
            [
              {
                provider: CONFIGURATIONS_PROVIDER_KEY,
                property: {
                  namespace: PULSE_FEATURE_NAME,
                  featureName: PulseConfigurationKeys.ToggleDiscountLabelByWsp,
                  defaultValue: false,
                },
              },
              false,
            ],
          ],
        ],
      ],
      [
        'EQ',
        [
          {
            provider: 'parent',
            property: 'productData',
            transform: function (args: {
              product: {
                prices?: { discountPercentage: number }[];
                priceRanges?: { discount: FloatRange }[];
              };
            }) {
              return (
                (args?.product?.prices?.[0]?.discountPercentage ??
                  args?.product?.priceRanges?.[0]?.discount?.max ??
                  0) > 0
              );
            }.toString(),
          },
          true,
        ],
      ],
    ],
  ],
  styles: {
    classes: ['d-block', 'position-absolute', 'badge-success'],
    style: {
      top: '25px',
      right: '0',
    },
    variables: {
      '--discount-label-width': 'calc(5.625rem / 1.8)',
      '--discount-label-height': 'calc(1.6875rem / 1.2)',
    },
  },
  inputs: {
    discount: {
      provider: 'parent',
      property: 'productData',
      transform: function (args: {
        product: {
          prices?: { discountPercentage: number }[];
          priceRanges?: { discount: FloatRange }[];
        };
      }) {
        if (args?.product?.prices?.[0]?.discountPercentage) {
          return {
            min: args?.product?.prices?.[0]?.discountPercentage,
            max: args?.product?.prices?.[0]?.discountPercentage,
          };
        }
        return args?.product?.priceRanges?.[0]?.discount;
      }.toString(),
    },
  },
};
